export const PersonalInformationDisclosure = {
  PageName: {
    HeaderTitle: '個人情報提供設定',
  },
  Button: {
    Setting: '設定する',
  },
  Label: {
    Instructions: 'お客様データ利用に関する設定を行います。',
    ThirdPartyDisclosureSetting: '第三者提供設定',
    NoProvision: '現在、お客様への第三者提供依頼はありません。',
    EndProvision: '以下のキャンペーンは終了しました。',
  },
};
